<template>
<div class="error-pane">
    <div class="preicon">
      <IosDocumentOutline class="no-data-icon"></IosDocumentOutline>
    </div>
    <div class="display-text">
      <span>{{$t("图片加载失败#!!!#src/pages/H5/Cloud/components/imagepreview/components/loaderror.vue_1")}}</span>
    </div>
  </div>
</template>

<script>
import IosDocumentOutline from "../icons/ios-document-outline.vue";

export default {
  components: {
    IosDocumentOutline,
  },
};
</script>

<style lang="scss" scoped>
.error-pane {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .preicon {
    .no-data-icon {
      width: 48px;
      height: 48px;
      color: #fff;
      fill: currentColor;
    }
  }

  .display-text {
    margin: 0;
    padding: 0;
    line-height: 12px;

    span {
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>
